var map = {
	"./abtelecom.jpg": "./src/assets/img/abtelecom.jpg",
	"./academiamaranhense.png": "./src/assets/img/academiamaranhense.png",
	"./alexssandro.jpeg": "./src/assets/img/alexssandro.jpeg",
	"./amanda.jpg": "./src/assets/img/amanda.jpg",
	"./anatel.jpg": "./src/assets/img/anatel.jpg",
	"./avatar.png": "./src/assets/img/avatar.png",
	"./carloshenrique.jpg": "./src/assets/img/carloshenrique.jpg",
	"./cayo.jpeg": "./src/assets/img/cayo.jpeg",
	"./celplan.jpg": "./src/assets/img/celplan.jpg",
	"./cisco.jpg": "./src/assets/img/cisco.jpg",
	"./cla.jpg": "./src/assets/img/cla.jpg",
	"./cnpq.jpg": "./src/assets/img/cnpq.jpg",
	"./cover.png": "./src/assets/img/cover.png",
	"./crea.jpg": "./src/assets/img/crea.jpg",
	"./cursoRFBanner.png": "./src/assets/img/cursoRFBanner.png",
	"./engcomp.png": "./src/assets/img/engcomp.png",
	"./fapead.jpg": "./src/assets/img/fapead.jpg",
	"./fapema.jpg": "./src/assets/img/fapema.jpg",
	"./fiema.jpg": "./src/assets/img/fiema.jpg",
	"./header-background.jpg": "./src/assets/img/header-background.jpg",
	"./header-logo.png": "./src/assets/img/header-logo.png",
	"./ifam.jpg": "./src/assets/img/ifam.jpg",
	"./jaironviana.jpg": "./src/assets/img/jaironviana.jpg",
	"./leonardo.jpg": "./src/assets/img/leonardo.jpg",
	"./lig16.jpg": "./src/assets/img/lig16.jpg",
	"./logo-geticom.png": "./src/assets/img/logo-geticom.png",
	"./lucasjeferson.jpg": "./src/assets/img/lucasjeferson.jpg",
	"./luiscarlos.jpg": "./src/assets/img/luiscarlos.jpg",
	"./mariano.jpg": "./src/assets/img/mariano.jpg",
	"./pecs.jpg": "./src/assets/img/pecs.jpg",
	"./pedrotomazeti.jpeg": "./src/assets/img/pedrotomazeti.jpeg",
	"./pucrio.png": "./src/assets/img/pucrio.png",
	"./rafael.jpg": "./src/assets/img/rafael.jpg",
	"./rogerio.jpg": "./src/assets/img/rogerio.jpg",
	"./romulopassosdejesus.jpeg": "./src/assets/img/romulopassosdejesus.jpeg",
	"./sandra.jpg": "./src/assets/img/sandra.jpg",
	"./schenaid.jpeg": "./src/assets/img/schenaid.jpeg",
	"./thiagogonzalez.jpg": "./src/assets/img/thiagogonzalez.jpg",
	"./tvn.jpg": "./src/assets/img/tvn.jpg",
	"./uema-logo.png": "./src/assets/img/uema-logo.png",
	"./uff.jpg": "./src/assets/img/uff.jpg",
	"./usp.jpg": "./src/assets/img/usp.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*$";